import { createGlobalStyle } from 'styled-components'

const GlobalStyles = createGlobalStyle`
  * {
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    font-family:'Lexend', sans-serif !important;
  }

  html {
    width: 100%;
    font-size: 62.5%;
  }

  body, #root {
    width: 100%;
    height: 100%;
    display:flex;
    min-height: 100vh;
    position: relative;
    background-color: #f6f8fd;
  }

  body {
    font-family: 'Lexend', sans-serif;
    font-display: swap;
  }

  select {
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    border-width: 0px;
    width: 100%;
    height: 100%;
    background: transparent;
  }

  select,
  option {
    /* Paragraph */
    font-family: 'Lato-Regular' !important;
    font-style: normal;
    font-weight: 500;
    font-size: 16px !important;
    line-height: 24px;

    /* gray / dark */
    color: #333333;
  }

  input:focus,
  textarea:focus {
    outline: none;
    box-shadow: none;

    /* tannat / default */
    border-color: blue !important;
  }

  // override MUI:
  .css-1v994a0,
  .css-195y93z-MuiButtonBase-root-MuiPickersDay-root:not(.Mui-selected),
  .css-1w13o7u-MuiTypography-root, 
  .css-bkrceb-MuiButtonBase-root-MuiPickersDay-root {
    font-size: 12px !important;
  }

  .image-gallery-content {
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .image-gallery {
    height: 100%;
  }

  .custom-toast-container {
    font-size: 15px;
    font-weight: bold;
  }
`

export default GlobalStyles
